'use strict';
var formValidation = require('../components/formValidation');
const { selectIso } = require('../phoneRegex');

function fillInStateField(countrySelector, stateFieldSelector, stateContainerSelector) {
    var $countryField = $(countrySelector);
    var $statesField = $(stateFieldSelector);
    var $stateContainer = $(stateContainerSelector);
    $statesField.empty();

    var stateSelectedCode = $countryField.val();

    var hasStates = $countryField.find('option:selected').data('hasstate');
    if (hasStates) {
        // build new list
        var countryStates = window.states[stateSelectedCode];
        for (var idx in countryStates) {
            var state = countryStates[idx];
            $statesField.append('<option value="'+ state.value+ '" ' + (idx == 0 ? 'selected' : '') + '>' +  state.label.toUpperCase() + '</option>');
        }
        console.log("Remove dnone class " + stateContainerSelector + " >> " + $stateContainer);
        $stateContainer.removeClass('d-none');
        $statesField.attr('required', true);
    } else {
        if (!$stateContainer.hasClass('d-none')) {
            $stateContainer.addClass('d-none');
        }
        $statesField.attr('required', false);
    }
}



module.exports = {
    submitRegistration: function () {
        $(document).on("submit", "form.registration", function (e) {
            $($(this)).find('.invalid-feedback').empty();
        });
    },
    submitProfile: function () {
        $('form.edit-profile-form').submit(function (e) {
            var $form = $(this);
            e.preventDefault();
            var url = $form.attr('action');
            $form.spinner().start();
            $('form.edit-profile-form').trigger('profile:edit', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: $form.serialize(),
                success: function (data) {
                    $form.spinner().stop();
                    if (!data.success) {
                        formValidation($form, data);
                    } else {
                        location.href = data.redirectUrl;
                    }
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                    $form.spinner().stop();
                }
            });
            return false;
        });
    },

    submitPassword: function () {
        $('form.change-password-form').submit(function (e) {
            var $form = $(this);
            e.preventDefault();
            var successTitle = $('.change-password-title').data('success-title'),
                successMsg = $('.change-password-body').data('success-msg');
            var url = $form.attr('action');
            $form.spinner().start();
            $('form.change-password-form').trigger('password:edit', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: $form.serialize(),
                success: function (data) {
                    $form.spinner().stop();
                    if (!data.success) {
                        formValidation($form, data);
                    } else {
                        $('.change-password-title').text(successTitle);
                        $('.change-password-body').empty()
                            .append('<div class="request-password-body"><p>' + successMsg + '</p></div>');
                        location.href = data.redirectUrl;
                    }
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                    $form.spinner().stop();
                }
            });
            return false;
        });
    },
    ModalPassword: function () {
        var modalPassword = $('.modal-password'),
            closeModal = modalPassword.find('.close');

        if (modalPassword.lenght > 0) return;

        closeModal.on('click', function () {
            modalPassword.removeClass('show');
        })
    },

    jQueryDataPicker: function () {

        var dateDropdownsOptions = {
            submitFieldName: 'skp-select-date',
            defaultDateFormat: 'dd/mm/yyyy',
            submitFormat: 'unix',
            defaultDateFormat: 'unix',
            daySuffixes: false,
            dayLabel: window.Resources.LABEL_DAY,
            monthLabel: window.Resources.LABEL_MONTH,
            yearLabel: window.Resources.LABEL_YEAR,
            monthLongValues: [
                window.Resources.LABEL_MONTHS_JANUARY,
                window.Resources.LABEL_MONTHS_FEBRUARY,
                window.Resources.LABEL_MONTHS_MARCH,
                window.Resources.LABEL_MONTHS_APRIL,
                window.Resources.LABEL_MONTHS_MAY,
                window.Resources.LABEL_MONTHS_JUNE,
                window.Resources.LABEL_MONTHS_JULY,
                window.Resources.LABEL_MONTHS_AUGUST,
                window.Resources.LABEL_MONTHS_SEPTEMBER,
                window.Resources.LABEL_MONTHS_OCTOBER,
                window.Resources.LABEL_MONTHS_NOVEMBER,
                window.Resources.LABEL_MONTHS_DECEMBER
            ]
        }
        if ($('#skp-select-date').data("birthdateday") && $('#skp-select-date').data("birthdatemonth") && $('#skp-select-date').data("birthdateyear")) {
            let birthday = new Date(
                parseInt($('#skp-select-date').data("birthdateyear")), 
                parseInt($('#skp-select-date').data("birthdatemonth")), 
                parseInt($('#skp-select-date').data("birthdateday"))
            );
            dateDropdownsOptions.defaultDate = Math.floor(birthday.valueOf() / 1000);
        }

        $("#skp-select-date").dateDropdowns(dateDropdownsOptions);
    },

    EditProfile: function () {
        $('.btn-save[name="save"]').click(function (e) {
            $('.edit-profile-form').find('.invalid-feedback').empty();
        });

        $('body').on('change', ".select2-country" , function () {
            fillInStateField($(this), ".select2-country", billingStateContainerSelector);
        });
    
        function hideGender() {
            if ($('#dwfrm_profile_byEmail').is(':checked')) {
                $('#dwfrm_profile_civility_1').attr('required', true);
                $('#radio-buttons').removeClass("hide")
                $('#radio-buttons').addClass("skp-gender-radio")
            } else {
                $('#dwfrm_profile_civility_1').removeAttr('required')
                $('#radio-buttons').addClass("hide");
                $('#radio-buttons').removeClass("skp-gender-radio")
                $('#dwfrm_profile_civility_1').removeAttr('aria-required')
            }
        }
        hideGender();

        $('#dwfrm_profile_byEmail').on('click', function () {
            hideGender();
        });

        $("#radio-buttons").on("chicked", function () {
            $('#radio-buttons').addClass('skp-gender-radio');
        });

        selectIso();


        var valSelect = $(".skp-select-profile-date select");

        $(valSelect).each(function () {
            if ($(this).get(0).selectedIndex === 0) {
                $(this).removeClass('color-black').addClass('color-gray');
            } else {
                $(this).addClass('color-black').removeClass('color-gray');;
            }
        });

        $('.date-dropdowns .day').on('change', function () {
            var valSelect = $(".date-dropdowns .day");
            if (valSelect[0].selectedIndex === 0) {
                valSelect.removeClass('color-black').addClass('color-gray');
            } else {
                valSelect.addClass('color-black').removeClass('color-gray');;
            }
        });

        $('.date-dropdowns .month').on('change', function () {
            var valSelect = $(".date-dropdowns .month");
            if (valSelect[0].selectedIndex === 0) {
                valSelect.removeClass('color-black');
            } else {
                valSelect.addClass('color-black');
            }
        });

        $('.date-dropdowns .year').on('change', function () {
            var valSelect = $(".date-dropdowns .year");
            if (valSelect[0].selectedIndex === 0) {
                valSelect.removeClass('color-black');
            } else {
                valSelect.addClass('color-black');
            }
        });
    }
};

if($('.skp-download-invoice .js-track-select').children().length === 0){
    $('.js-select2-invoices').addClass('remove-margin');
    $('.no-block-return').addClass('remove-margin');
};